import React from 'react';

export interface EmailRoleRowProps {
  emailSlot: React.ReactNode;
  roleSlot: React.ReactNode;
  /** id of the element in `emailSlot` this label should associate with
   *  (e.g. an Input's `id`) — omit when there's nothing to associate with
   *  (plain text standing in for the field, as in MemberAccessDrawer). */
  emailFor?: string;
  /** Same as `emailFor`, for the role field. */
  roleFor?: string;
}

/**
 * Email + Role — the row shared by every member-access surface (both
 * invite dialogs, MemberAccessDrawer). Callers supply the slots — an
 * editable Input for an invite vs. plain text for an existing member; a
 * role Select vs. a static label — so this only owns the shared label/row
 * layout, not the field semantics.
 */
export function EmailRoleRow({ emailSlot, roleSlot, emailFor, roleFor }: EmailRoleRowProps) {
  return (
    <div className="flex items-start gap-2">
      <div className="flex min-w-0 flex-1 flex-col gap-1.5">
        <label htmlFor={emailFor} className="text-body-sm-medium text-foreground">Email</label>
        {emailSlot}
      </div>
      <div className="flex w-28 shrink-0 flex-col gap-1.5">
        <label htmlFor={roleFor} className="text-body-sm-medium text-foreground">Role</label>
        {roleSlot}
      </div>
    </div>
  );
}
